import '../App.css';
import React, { useState, useEffect } from 'react';
import { Button, ActionButton, Text, Tooltip, TooltipTrigger } from '@adobe/react-spectrum';
import Delete from '@spectrum-icons/workflow/Delete';
import {defaultTheme, Provider} from '@adobe/react-spectrum';
import Highlighter from './Highlighter';
import { logHighlightEvent } from '../logging';

function SelectionToolbar({...properties}) {
    const BUTTON_STATES = {
        highlighter: <Delete size="S"/>,
        cursor: <Highlighter size="S"/>,
    };

    var range = properties.range[0].props.range;

    function addHighlight() {
        var index = properties.highlights.indexOf(range);
        var newHighlight = properties.highlights[index];
        newHighlight.highlight = true;
        properties.setHighlights(properties.highlights.toSpliced(index, 1).concat(newHighlight));
        var newWordCount = properties.countNumWords(range.text);
        properties.setWordCount(properties.wordCount + newWordCount);
    }

    function deleteHighlight() {
        var index = properties.highlights.indexOf(range);
        var snappedRange = properties.highlights[index];
        properties.setHighlights(properties.highlights.toSpliced(index, 1));
        var newWordCount = properties.countNumWords(range.text);
        properties.setWordCount(properties.wordCount - newWordCount);

        var log = {
            type: "delete",
            participantId: properties.participantId,
            newWordCount: (properties.wordCount - newWordCount),
            snappedRange: snappedRange
        }

        logHighlightEvent(log);
    }

    function previewAddHighlight() {
        var potentialWordCount = properties.countNumWords(range.text);
        properties.setShadowWordCount(properties.wordCount + potentialWordCount);
    }

    function stopPreviewAddHighlight() {
        properties.setShadowWordCount(properties.wordCount);
    }


    function previewDeleteHighlight() {
        var potentialWordCount = properties.countNumWords(range.text);
        properties.setProgressWordCount(properties.wordCount - potentialWordCount);
    }

    function stopPreviewDeleteHighlight() {
        properties.setProgressWordCount(properties.wordCount);
    }
    

    function mouseEnter() {
        if (properties.selectedTool === 'highlighter'){
            previewDeleteHighlight();
        }
        else if (properties.selectedTool === 'cursor') {
            previewAddHighlight();
        }
    }

    function mouseLeave() {
        if (properties.selectedTool === 'highlighter'){
            stopPreviewDeleteHighlight();
        }
        else if (properties.selectedTool === 'cursor') {
            stopPreviewAddHighlight();
        }
    }

    function mouseClick() {
        if (properties.selectedTool === 'highlighter'){
            deleteHighlight();
        }
        else if (properties.selectedTool === 'cursor') {
            addHighlight();
            properties.updateShowToolbar(false);
        }
    }

    return (
        <div className="blackButton" 
            onClick={mouseClick}
            onMouseEnter={mouseEnter}
            onMouseLeave={mouseLeave}
            style={ range.showToolbar ? 
                { 
                    visibility: 'visible',
                    position: 'absolute',
                    top: 'calc(0% - 30px)',
                    left: '100%',
                    cursor: 'pointer',
                } :
                {
                    visibility: 'hidden',
                    position: 'absolute',        
                }}
            >

        {BUTTON_STATES[properties.selectedTool]}
        </div>
    );
}

export default SelectionToolbar;